/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverDailyMetricAdminDto } from '../models/DriverDailyMetricAdminDto';
import type { Pagination1OfDriverDailyMetricAdminDto } from '../models/Pagination1OfDriverDailyMetricAdminDto';
import type { PostDriverDailyMetricsManualRunAdminRequest } from '../models/PostDriverDailyMetricsManualRunAdminRequest';
import type { ValidateDriverDailyMetricsManualRunAdminResponse } from '../models/ValidateDriverDailyMetricsManualRunAdminResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverDailyMetricsService {
    /**
     * **Required Policy:** `RunDriverDailyMetricsManually`
     * @returns ValidateDriverDailyMetricsManualRunAdminResponse OK
     * @throws ApiError
     */
    public static validateRunDriverDailyMetricsManuallyAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverDailyMetricsManualRunAdminRequest,
    }): CancelablePromise<ValidateDriverDailyMetricsManualRunAdminResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverdailymetrics/run-manually/validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `RunDriverDailyMetricsManually`
     * @returns any OK
     * @throws ApiError
     */
    public static runDriverDailyMetricsManuallyAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverDailyMetricsManualRunAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverdailymetrics/run-manually',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverDailyMetrics`
     * @returns Pagination1OfDriverDailyMetricAdminDto OK
     * @throws ApiError
     */
    public static getDriverDailyMetricsAdmin({
        driverId,
        regionId,
        startDate,
        endDate,
        page,
        limit,
    }: {
        driverId?: number,
        regionId?: number,
        startDate?: string,
        endDate?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverDailyMetricAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverdailymetrics',
            query: {
                'driverId': driverId,
                'regionId': regionId,
                'startDate': startDate,
                'endDate': endDate,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverDailyMetrics`
     * @returns DriverDailyMetricAdminDto OK
     * @throws ApiError
     */
    public static getDriverDailyMetricByIdAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverDailyMetricAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverdailymetrics/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
